import PropTypes from 'prop-types'
import React from 'react'
import ResponsiveDataTable from '~/react/components/ResponsiveDataTable'
import useColumns from './useColumns'

const LargePaymentsTable = ({payments, isLoading, onClickRow}) => {
  const {columns} = useColumns()

  return (
    <ResponsiveDataTable
      columns={columns}
      enableSorting
      onClickRow={onClickRow}
      data={payments}
      isLoading={isLoading}
      sortByValue={[{id: 'createdAt', desc: true}]}
    />
  )
}

LargePaymentsTable.propTypes = {
  payments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClickRow: PropTypes.func.isRequired,
}

export default LargePaymentsTable
